import { CellContext } from '@tanstack/react-table';
import { PurchaseOrderRow, getTableMeta } from '../../helpers';
import { SkeletonizedValue } from '@round/ui-kit';
import styles from './POCell.module.css';
import cn from 'classnames';
import { Button } from '@round/whitelabel-ui';
import { isEmptyObject } from 'utility/utility';

type Context = CellContext<PurchaseOrderRow, any>;

const POCell = ({ table, row: { original } }: Context) => {
    const { isLoading: isFetching, onEditPurchaseOrder, onDeletePurchaseOrder } = getTableMeta(table);
    const { description, number, request_reference, is_invoiced } = original;
    const poIdentifier = number || request_reference || '-';
    const isCompleted = false;
    const isActive = !isCompleted && !!number;
    const statusLabel = isCompleted ? 'Completed' : isActive ? 'Active' : 'Draft';
    const isLoading = isFetching && isEmptyObject(original);

    return (
        <div className={styles.container}>
            <span className={cn(styles.statusStrip, { [styles.active]: isActive, [styles.completed]: isCompleted })} />

            <p className={styles.poIdentifier}>
                <SkeletonizedValue isInitialized={!isLoading}>{poIdentifier}</SkeletonizedValue>
            </p>
            <p className={styles.copy}>
                <SkeletonizedValue isInitialized={!isLoading}>{statusLabel}</SkeletonizedValue>
            </p>
            <p className={styles.copy}>
                <SkeletonizedValue isInitialized={!isLoading}>{description}</SkeletonizedValue>
            </p>

            <div className={styles.actions}>
                <Button
                    appearance="ghost"
                    type="button"
                    className={styles.action}
                    disabled={is_invoiced}
                    onClick={() => onEditPurchaseOrder(original)}
                >
                    Edit
                </Button>
                <Button
                    appearance="ghost"
                    type="button"
                    className={cn(styles.action, styles.delete)}
                    disabled={is_invoiced}
                    onClick={() => onDeletePurchaseOrder(original)}
                >
                    Delete
                </Button>
            </div>
        </div>
    );
};

export default POCell;
